import initTextCardSlider from "../initTextCardSlider.js";

document.addEventListener("DOMContentLoaded", () => {
  initTextCardSlider();
});
